"use client";
// Tenant colours in light mode are used exactly as the tenant chose them:
// picking colours with enough contrast on a light background is the tenant's
// responsibility, so no readability check happens here. Only the dark palette
// checks readability — there `brandText` / `brand2Text` are computed (lightened
// until readable on the dark paper) and used as the text colour.
import { alpha } from "@mui/system/colorManipulator";
import { common } from "@mui/material/colors";
import { error, info, neutral, success, warning } from "../colors";
import { getPrimary } from "../utils";
import { createBrandColor } from "@theme/shared/create-brand-color";

export const createPalette = (config) => {
  const { colorPreset, branding } = config;

  // Tenant branding. `clientPrimary` → palette.primary + the `brand` token,
  // `clientSecondary` → palette.secondary + the `brand2` token (the tokens are
  // what the ~29 client components read). Oxygen defaults as fallback.
  const clientPrimary = createBrandColor(branding?.clientPrimary);
  const clientSecondary =
    createBrandColor(branding?.clientSecondary) ?? createBrandColor("#0D3D6E");

  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[900], 0.38),
      disabledBackground: alpha(neutral[900], 0.12),
      focus: alpha(neutral[900], 0.16),
      hover: alpha(neutral[900], 0.04),
      selected: alpha(neutral[900], 0.12),
    },
    background: {
      default: "#f9fafb",
      paper: common.white,
      tab: "#c5c7cb",
    },
    divider: "#E2E8F0",
    line: "#E2E8F0",
    brand: clientPrimary?.main ?? "#E17000",
    brand2: clientSecondary.main,
    // Text/icon variants of brand/brand2. Light mode uses the tenant colour as
    // chosen; only dark mode adjusts it for readability.
    brandText: clientPrimary?.main ?? "#E17000",
    brand2Text: clientSecondary.main,
    grayscale: common.black,
    error,
    info,
    mode: "light",
    neutral,
    primary: clientPrimary ?? getPrimary(colorPreset),
    secondary: clientSecondary,
    success,
    text: {
      primary: "#4b5563",
      secondary: neutral[500],
      disabled: alpha(neutral[900], 0.38),
    },
    warning,
  };
};
